<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <!--<div v-if="deletedItem" class="alert alert-success">{{ deletedItem['name'] }} {{$t('notifications.deleted')}}</div>-->
          <!--<div v-if="error" class="alert alert-danger">{{ error }}</div>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link
                :to="{ name: 'EXCMAgreementTypeCreate' }"
                class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <div v-if="items.length > 0">
                    <table class="table table-sm table-striped table-hover">
                      <thead>
                      <tr>
                        <th>{{$t('views.excmagreementtypes.update.title')}}</th>
                        <th colspan="1" />
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                              v-for="item in items"
                              :key="item['@id']">
                        <td>
                          {{ item['title'] }}
                          <!--                          <router-link-->
                          <!--                            v-if="item"-->
                          <!--                            :to="{name: 'EXCMAgreementTypeShow', params: { id: item['@id'] }}">-->
                          <!--                            {{ item['title'] }}-->
                          <!--                          </router-link>-->
                        </td>
                        <!--                        <td>-->
                        <!--                          <router-link :to="{name: 'EXCMAgreementTypeShow', params: { id: item['@id'] }}">-->
                        <!--                            <span class="fa fa-search" aria-hidden="true" />-->
                        <!--                            <span class="sr-only">Show</span>-->
                        <!--                          </router-link>-->
                        <!--                        </td>-->
                        <td>
                          <router-link :to="{name: 'EXCMAgreementTypeUpdate', params: { id: item['@id'] }}">
                            <button class="float-right btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                          </router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <p v-else>{{ $t('views.excmagreementtypes.list.noTypes') }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div v-if="view">
                    <pagination
                      :view="view"
                      @getPage="getPage($event)"
                    ></pagination>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'excmagreementtype/del/deleted',
    error: 'excmagreementtype/list/error',
    items: 'excmagreementtype/list/items',
    isLoading: 'excmagreementtype/list/isLoading',
    view: 'excmagreementtype/list/view'
  }),

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMAgreementTypeList')
  },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmagreementtype/list/default'
  })
}
</script>
